import { CommentImageList } from "./styles";
import {FC, useCallback, useMemo} from "react";
import {Colors} from "@brg/ui";
import styled from "styled-components";
import ResizedImageEnhanced from "../../components/ResizedImageEnhanced";
import {useModal} from "../../../core";
import { FormatLinkedText } from "brg-longread";
import {getFormattedDate} from "../../helpers/getFormattedDate";
import {useTranslation} from "react-i18next";

const CommentItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`

const CommentName = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: -0.02em;
`

const CommentBlock = styled.div`
  display: flex;
  background: ${Colors.galBlack5};
  padding: 12px 16px;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
`

const CommentText = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
`

const CommentDate = styled.div`
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  color: ${Colors.galBlack47};
  text-align: right;
`

export const CommentHomeworkItem: FC<{comment: any}> = ({comment}) => {

    const modal = useModal();
    const { i18n: { language } } = useTranslation();

    const commentTime = useMemo(() => getFormattedDate(comment?.created, language), [comment?.created, language])

    // @ts-ignore
    const openAttachment = useCallback((attachmentId) => {

        modal.show('previewer', {
            activeAttachmentId: attachmentId,
            attachmentList: comment?.attachments || []
        })
    }, [comment?.attachments])

    return <CommentItem>
        <CommentName>{`${comment?.account?.name} ${comment?.account?.surName}`}</CommentName>
        <CommentBlock>
            <CommentText><FormatLinkedText text={comment?.text}/></CommentText>
            <CommentImageList fullWidth>
                {comment?.attachments?.map((attachment: any) => <ResizedImageEnhanced onClick={() => openAttachment(attachment?.attachmentId)} files={attachment?.files}/>)}
            </CommentImageList>
            <CommentDate>{commentTime}</CommentDate>
        </CommentBlock>
    </CommentItem>
}import { CommentImageList } from "./styles";
import {FC, useCallback, useMemo} from "react";
import {Colors} from "@brg/ui";
import styled from "styled-components";
import ResizedImageEnhanced from "../../components/ResizedImageEnhanced";
import {useModal} from "../../../core";
import { FormatLinkedText } from "brg-longread";
import {getFormattedDate} from "../../helpers/getFormattedDate";
import {useTranslation} from "react-i18next";

const CommentItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`

const CommentName = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: -0.02em;
`

const CommentBlock = styled.div`
  display: flex;
  background: ${Colors.galBlack5};
  padding: 12px 16px;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
`

const CommentText = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
`

const CommentDate = styled.div`
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  color: ${Colors.galBlack47};
  text-align: right;
`

export const CommentHomeworkItem: FC<{comment: any}> = ({comment}) => {

    const modal = useModal();
    const { i18n: { language } } = useTranslation();

    const commentTime = useMemo(() => getFormattedDate(comment?.created, language), [comment?.created, language])

    // @ts-ignore
    const openAttachment = useCallback((attachmentId) => {

        modal.show('previewer', {
            activeAttachmentId: attachmentId,
            attachmentList: comment?.attachments || []
        })
    }, [comment?.attachments])

    return <CommentItem>
        <CommentName>{`${comment?.account?.name} ${comment?.account?.surName}`}</CommentName>
        <CommentBlock>
            <CommentText><FormatLinkedText text={comment?.text}/></CommentText>
            <CommentImageList fullWidth>
                {comment?.attachments?.map((attachment: any) => <ResizedImageEnhanced onClick={() => openAttachment(attachment?.attachmentId)} files={attachment?.files}/>)}
            </CommentImageList>
            <CommentDate>{commentTime}</CommentDate>
        </CommentBlock>
    </CommentItem>
}